import { j as e } from "../../modules/index.es3.js";
import { Slot as v } from "../../modules/index.es7.js";
import * as t from "react";
import { cn as a } from "../../utils/styling.es.js";
import { buttonVariants as R, buttonIconVariants as w } from "./Button.styles.es.js";
import { InsertedContent as y } from "./InternalContent.es.js";
const C = t.forwardRef(
  ({
    className: l,
    appearance: m,
    variant: i,
    size: s,
    icon: f,
    disabled: u = !1,
    children: p,
    asChild: d = !1,
    loading: r = !1,
    ...x
  }, h) => {
    const n = t.useRef(null);
    t.useImperativeHandle(h, () => n.current, []);
    const c = t.useRef();
    t.useEffect(() => {
      if (r) {
        const o = document.createElement("div");
        o.id = "loader", c.current = o, n.current.append(o);
      } else
        n.current?.querySelector("#loader")?.remove();
    }, [r]);
    const j = d ? v : "button";
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          className: a(
            R({ appearance: m, variant: i, size: s, icon: f, className: l }),
            r && "pointer-events-none"
          ),
          ref: n,
          disabled: u,
          ...x,
          children: p
        }
      ),
      /* @__PURE__ */ e.jsx(y, { container: c.current, children: r && /* @__PURE__ */ e.jsxs(
        "svg",
        {
          className: a(
            "ml-1.5 animate-spin",
            w({ size: s })
          ),
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          children: [
            /* @__PURE__ */ e.jsx(
              "circle",
              {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
              }
            ),
            /* @__PURE__ */ e.jsx(
              "path",
              {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }
            )
          ]
        }
      ) })
    ] });
  }
);
C.displayName = "Button";
export {
  C as default
};
//# sourceMappingURL=Button.es.js.map
